import at from 'lodash/at';
import L from 'leaflet';

import defaultPinIcon from '../static/hoop-pin.svg';
import reebokPinIcon from '../static/reebok/reebok-marker.svg';
import redbullPinIcon from '../static/redbull/pin.png';
import redbullEventIcon from '../static/redbull/star.svg';
import { map as mapConfig } from '../app/config';

export const POSITION_CLASSES = {
  bottomleft: 'leaflet-bottom leaflet-left',
  bottomright: 'leaflet-bottom leaflet-right',
  topleft: 'leaflet-top leaflet-left',
  topright: 'leaflet-top leaflet-right',
  bottom: 'leaflet-bottom',
  bottomcenter: 'leaflet-bottom leaflet-center',
  topcenter: 'leaflet-top leaflet-center',
  leftcenter: 'leaflet-left leaflet-v-center',
  rightcenter: 'leaflet-right leaflet-v-center',
  center: 'leaflet-center leaflet-v-center',
  quarterbottom: 'leaflet-quarterbottom',
  quarterbottomright: 'leaflet-quarterbottom leaflet-right',
  quarterbottomleft: 'leaflet-quarterbottom leaflet-left',
};

export const getMarkerIcon = (brand, activeFetchType, isRedbullEvent = false, isHalfcourtHoop = false, markerClusterRef) => {
  const zoom = markerClusterRef?.current?._zoom;

  if (brand === 'reebok') {
    return L.icon({ iconUrl: reebokPinIcon, iconSize: [ 60.3, 67.4 ] });
  }

  if (isRedbullEvent) {
    return L.icon({ iconUrl: redbullEventIcon, iconSize: [ 30, 28.5 ] });
  }

  if (isHalfcourtHoop && activeFetchType === "redbull") {
    return L.icon({ iconUrl: redbullPinIcon, iconSize: [ 30, 33.4 ] });
  }

  return L.icon({
    iconUrl: defaultPinIcon,
    iconSize: [ 45, 50 ],
    className: zoom === mapConfig.defaultZoomLevel ? 'hidden-marker' : '',
  });
};

export const capitalize = (str) => (
  str.charAt(0).toUpperCase() + str.slice(1)
);

export const getAddressShortName = (address) => at(address, [ 'town', 'city', 'county', 'state', 'province', 'country' ])
  .filter((v) => v && v.length > 0)
  .slice(0, 2)
  .join(', ');

export const formatGoogleLocationResult = (location) => {
  const { place_id, geometry, formatted_address, address_components } = location;

  const zipInfo = address_components.find((component) => component.types.includes('postal_code'));
  const zip = zipInfo ? (zipInfo.long_name || zipInfo.short_name) : '';

  const countryInfo = address_components.find((component) => component.types.includes('country'));
  const country = countryInfo ? (countryInfo.long_name || countryInfo.short_name) : '';

  const localityInfo = address_components.find((component) => component.types.includes('locality'));
  const locality = localityInfo ? (localityInfo.long_name || localityInfo.short_name) : '';

  const sublocalityInfo = address_components.find((component) => component.types.includes('sublocality'));
  const sublocality = sublocalityInfo ? (sublocalityInfo.long_name || sublocalityInfo.short_name) : '';

  const neighborhoodInfo = address_components.find((component) => component.types.includes('neighborhood'));
  const neighborhood = neighborhoodInfo ? (neighborhoodInfo.long_name || neighborhoodInfo.short_name) : '';

  const routeInfo = address_components.find((component) => component.types.includes('route'));
  const route = routeInfo ? (routeInfo.long_name || routeInfo.short_name) : '';

  const formattedLocation = {
    place_id,
    formatted_address,
    zip,
    country,
    locality,
    sublocality,
    neighborhood,
    route,
    latitude: geometry.location.lat,
    longitude: geometry.location.lng,
    placeLat: geometry.location.lat,
    placeLng: geometry.location.lng,
  };

  return formattedLocation;
};

export const parseLocationAreaName = (location) => {
  const availableNames = at(
    location,
    [ 'neighborhood', 'locality', 'sublocality', 'zip', 'country' ],
  )
    .filter((v) => v && v.length > 0);

  return availableNames[0];
};

// Searches firebase for matching hoop submissions
// export const onGeosearchShow = async (event) => {
//   const { location } = event;
//   const { address } = location.raw;
//   const searchRadiusInM = mapConfig.maxClusterDistanceInKm * 1000;
//   const submissionsRef = db.collection('submissions');
//   let results = [];

//   if (location.x && location.y) {
//     const center = [location.y, location.x];
//     const bounds = geohashQueryBounds(center, searchRadiusInM);
//     const promises = [];
//     for (const b of bounds) {
//       const q = db.collection('submissions')
//         .orderBy('location.geohash')
//         .startAt(b[0])
//         .endAt(b[1]);

//       promises.push(q.get());
//     }

//     // Collect all the query results together into a single list
//     const snapshots = await Promise.all(promises);
//     const matchingDocs = [];
//     for (const snap of snapshots) {
//       for (const doc of snap.docs) {
//         const coords = doc.get('location.coords');
//         const distanceInKm = distanceBetween([coords.latitude, coords.longitude], center);
//         if (distanceInKm <= mapConfig.maxClusterDistanceInKm) {
//           matchingDocs.push(doc);
//         }
//       }
//     }
//     results = matchingDocs;
//   } else if (address.postcode) {
//     results = await submissionsRef.where('location.postal_code', '==', address.postcode).get();
//   } else if (address.town) {
//     results = await submissionsRef.where('location.town', '==', address.town).get();
//   } else if (address.county) {
//     results = await submissionsRef.where('location.county', '==', address.county).get();
//   } else if (address.city) {
//     results = await submissionsRef.where('location.city', '==', address.city).get();
//   } else if (address.state) {
//     results = await submissionsRef.where('location.state', '==', address.state).get();
//   } else if (address.country) {
//     results = await submissionsRef.where('location.country', '==', address.country).get();
//   }

//   results.forEach((doc) => {
//     console.log('found matching doc from search', doc.data());
//   });
// };
